import { type IStage, movSitesV2 } from '@metservicedev/platforms-services-interface';
import type { ISiteUpdateEventBody } from '@metservicedev/platforms-services-interface/src/services/movSites/MovSitesV2Model';

interface UpdateSiteProps {
    data: ISiteUpdateEventBody;
    stage: IStage;
    movSiteId: string;
    metjwt: string;
    headers: any;
}

const updateSite = async ({ movSiteId, data, stage, metjwt, headers }: UpdateSiteProps): Promise<any> => {
    // If current site exists in new DB Update the site else create it in new DB.
    try {
        const response = await movSitesV2.http.update({
            token: metjwt,
            stage,
            body: {
                name: data.name,
                expectation: data.expectation,
                dataSignals: {
                    ...data.dataSignals,
                    verticalLevels: data.dataSignals.verticalLevels === null ? [0] : data.dataSignals.verticalLevels,
                },
                notes: data.notes ?? '',
                flagged: data.flagged ?? false,
                legacySiteIds: data.legacySiteIds ?? [],
            },
            movSiteId,
            headers,
        });
        return response;
    } catch (err) {
        console.error(err);
    }
};

export default updateSite;
